/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: BZA1gY3bmqLJ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSectionHeader.module.css"; // plasmic-import: BZA1gY3bmqLJ/css

createPlasmicElementProxy;

export type PlasmicSectionHeader__VariantMembers = {};
export type PlasmicSectionHeader__VariantsArgs = {};
type VariantPropType = keyof PlasmicSectionHeader__VariantsArgs;
export const PlasmicSectionHeader__VariantProps = new Array<VariantPropType>();

export type PlasmicSectionHeader__ArgsType = {
  subtitle?: string;
  title?: string;
  description?: string;
  showDescription?: boolean;
  showSubtitle?: boolean;
};
type ArgPropType = keyof PlasmicSectionHeader__ArgsType;
export const PlasmicSectionHeader__ArgProps = new Array<ArgPropType>(
  "subtitle",
  "title",
  "description",
  "showDescription",
  "showSubtitle"
);

export type PlasmicSectionHeader__OverridesType = {
  sectionHeader?: Flex__<"header">;
  top?: Flex__<"div">;
  subtitleText?: Flex__<"h3">;
  titleText?: Flex__<"h2">;
  descriptionText?: Flex__<"p">;
};

export interface DefaultSectionHeaderProps {
  subtitle?: string;
  title?: string;
  description?: string;
  showDescription?: boolean;
  showSubtitle?: boolean;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSectionHeader__RenderFunc(props: {
  variants: PlasmicSectionHeader__VariantsArgs;
  args: PlasmicSectionHeader__ArgsType;
  overrides: PlasmicSectionHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          subtitle: "tailor-made solution",
          title:
            "Customized Offerings for Diverse Medical Education Institutions",
          description:
            "MyEvaluations crafts specialized solutions for Graduate Medical Education, Physician Assistant Programs, and Nursing Programs, precisely meeting institution needs, fostering seamless education and optimal outcomes.",
          showDescription: false,
          showSubtitle: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <header
      data-plasmic-name={"sectionHeader"}
      data-plasmic-override={overrides.sectionHeader}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.sectionHeader
      )}
    >
      <div
        data-plasmic-name={"top"}
        data-plasmic-override={overrides.top}
        className={classNames("all", sty.top)}
      >
        {(() => {
          try {
            return $props.showSubtitle;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <h3
            data-plasmic-name={"subtitleText"}
            data-plasmic-override={overrides.subtitleText}
            className={classNames(
              "all",
              "h3",
              "h3__bvRZj",
              "__wab_text",
              sty.subtitleText
            )}
          >
            <React.Fragment>{$props.subtitle}</React.Fragment>
          </h3>
        ) : null}
        <h2
          data-plasmic-name={"titleText"}
          data-plasmic-override={overrides.titleText}
          className={classNames(
            "all",
            "h2",
            "h2__bvRZj",
            "__wab_text",
            sty.titleText
          )}
        >
          <React.Fragment>{$props.title}</React.Fragment>
        </h2>
      </div>
      {(() => {
        try {
          return $props.showDescription;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <p
          data-plasmic-name={"descriptionText"}
          data-plasmic-override={overrides.descriptionText}
          className={classNames(
            "all",
            "p",
            "p__bvRZj",
            "__wab_text",
            sty.descriptionText
          )}
        >
          <React.Fragment>{$props.description}</React.Fragment>
        </p>
      ) : null}
    </header>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  sectionHeader: [
    "sectionHeader",
    "top",
    "subtitleText",
    "titleText",
    "descriptionText"
  ],
  top: ["top", "subtitleText", "titleText"],
  subtitleText: ["subtitleText"],
  titleText: ["titleText"],
  descriptionText: ["descriptionText"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  sectionHeader: "header";
  top: "div";
  subtitleText: "h3";
  titleText: "h2";
  descriptionText: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionHeader__VariantsArgs;
    args?: PlasmicSectionHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSectionHeader__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSectionHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionHeader__ArgProps,
          internalVariantPropNames: PlasmicSectionHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "sectionHeader") {
    func.displayName = "PlasmicSectionHeader";
  } else {
    func.displayName = `PlasmicSectionHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionHeader = Object.assign(
  // Top-level PlasmicSectionHeader renders the root element
  makeNodeComponent("sectionHeader"),
  {
    // Helper components rendering sub-elements
    top: makeNodeComponent("top"),
    subtitleText: makeNodeComponent("subtitleText"),
    titleText: makeNodeComponent("titleText"),
    descriptionText: makeNodeComponent("descriptionText"),

    // Metadata about props expected for PlasmicSectionHeader
    internalVariantProps: PlasmicSectionHeader__VariantProps,
    internalArgProps: PlasmicSectionHeader__ArgProps
  }
);

export default PlasmicSectionHeader;
/* prettier-ignore-end */
